import { render, staticRenderFns } from "./BoxLayout.vue?vue&type=template&id=b839891e&scoped=true&"
import script from "./BoxLayout.vue?vue&type=script&lang=js&"
export * from "./BoxLayout.vue?vue&type=script&lang=js&"
import style0 from "./BoxLayout.vue?vue&type=style&index=0&id=b839891e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b839891e",
  null
  
)

export default component.exports